<template>
	<el-carousel
		v-if="noticesContentList.length > 0"
		:interval="5000"
		arrow="never"
		class="u-m-l-15 u-m-r-15 u-m-b-10"
		direction="vertical"
		height="40px"
		indicator-position="none">
		<el-carousel-item v-for="(itemData, index) in noticesContentList" :key="index">
			<el-alert :closable="false" type="info">
				<template v-slot:title>
					<div class="u-flex u-font-weight-bold u-font-18" style="color: #303133">
						<span
							v-for="(itemContent, index) in itemData.contentList"
							:key="index"
							:class="itemContent.includes('red') ? 'u-color-red' : ''"
							class="u-m-r-5">
							{{ itemContent.replace('red', '') }}
						</span>
						<div class="u-m-l-20">
							<el-button class="u-font-weight-bold u-font-18" type="text" @click="onToDealHint(itemData)">
								{{ itemData.btnContent }}
							</el-button>
						</div>
					</div>
				</template>
			</el-alert>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import {getNoticeContent} from '@/util/notices'
import {mapGetters} from 'vuex'

var sensors = require('sa-sdk-javascript')
export default {
	name: 'noticesHint',
	components: {},
	computed: {
		...mapGetters(['userInfo']),
	},
	data() {
		return {
			noticesInterval: null,
			noticesContentList: [],
		}
	},
	watch: {
		noticesContentList: {
			handler(newVal = []) {
				this.$emit('update:isShow', newVal.length > 0)
			},
			immediate: true,
		},
	},
	mounted() {
		//如果为管理员，则直接退出
		let {distAccount = {}} = this.userInfo || {}
		if (this.validatenull(distAccount)) {
			return
		}
		//定时获取通知列表
		this.clearInterval()
		getNoticeContent(this.noticesContentList)
		// this.noticesInterval = setInterval(() => {
		//   getNoticeContent(this.noticesContentList)
		// }, 10 * 60 * 1000)

		this.noticesInterval = setInterval(
			() => {
				getNoticeContent(this.noticesContentList)
			},
			20 * 60 * 1000,
		)
	},
	beforeDestroy() {
		this.clearInterval()
	},
	methods: {
		onToDealHint(itemData) {
			let {path, query = {}, btnContent = ''} = itemData
			let currentPath = this.$route.path
			console.log('onToDealHint------', itemData, currentPath)
			if (currentPath === path || currentPath.includes(path)) {
				if (currentPath === '/insurance/policy/index') {
					this.$Bus.$emit('onNoticesHint', query)
				} else {
					this.$message.info('请在当前页面直接操作！')
				}
				return
			}
			//埋点
			sensors.track('notices_click', {
				project: '通知栏',
				path: '/insurance/policy/index',
				content: btnContent,
				title: query.status || '',
			})

			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: path,
				}),
				query,
			})
		},
		//清除循环
		clearInterval() {
			if (this.noticesInterval) {
				clearInterval(this.noticesInterval)
				this.noticesInterval = null
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.u-color-red {
	color: red;
}
</style>
